<template>
  <div ui-view="" class="app-body" id="view">
    <page-header title="NTREE 결재자/참조자 관리" description="NTREE 티켓 자동 생성 시, 출입 위치별 결재자, 참조자 (사번,DL) 목록을 관리합니다." />
    <div class="page-body p-30">
      <div class="row">
        <div class="col-7 pr-0">
          <div id="detail-info"
               style="background: rgb(246, 247, 248);
                    box-sizing: border-box;
                    border-width: 1px 1px 1px 1px;
                    border-top-style: solid;
                    border-right-style: solid;
                    border-left-style: solid;
                    border-bottom-style: solid;
                    border-top-color: rgb(226, 226, 226);
                    border-right-color: rgb(226, 226, 226);
                    border-bottom-color: rgb(226, 226, 226);
                    border-left-color: rgb(226, 226, 226);
                    border-image: initial;
                    height: 1125px;
                    position:relative;
                    overflow: visible;"
               ui-jp="mCustomScrollbar">
              <table class="tbl">
              <!--<colgroup><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"></colgroup>-->
              <colgroup>
                <col width="200px">
                <col width="auto">
                <col width="150px">
              </colgroup>
              <thead>
              <tr>
                <th>기본 / 링크</th>
                <th>말줄임 / 줄바꿈</th>
                <th>금액 우측 정렬</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>기본 텍스트</td>
                <td class="ellipsis">
                  <span data-toggle="tooltip" data-placement="left" data-original-title="내용이 길어질 때 말줄임 되는 텍스트 입니다. 내용이 길어질 때 말줄임 되는 텍스트 입니다. 내용이 길어질 때 말줄임 되는 텍스트 입니다. 내용이 길어질 때 말줄임 되는 텍스트 입니다.">내용이 길어질 때 말줄임 되는 텍스트 입니다. 내용이 길어질 때 말줄임 되는 텍스트 입니다. 내용이 길어질 때 말줄임 되는 텍스트 입니다. 내용이 길어질 때 말줄임 되는 텍스트 입니다.</span>
                </td>
                <td class="text-right">3,000,000</td>
              </tr>
              <tr>
                <td>
                  <a href="#" class="under-line">링크 텍스트</a>
                </td>
                <td>내용이 길어질 때 줄바꿈 되는 텍스트 입니다. 내용이 길어질 때 줄바꿈 되는 텍스트 입니다.</td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-5 pl-0">
          <div id="detail-info"
               style="background: rgb(246, 247, 248);
                    box-sizing: border-box;
                    border-width: 1px 1px 1px 0px;
                    border-top-style: solid;
                    border-right-style: solid;
                    border-bottom-style: solid;
                    border-top-color: rgb(226, 226, 226);
                    border-right-color: rgb(226, 226, 226);
                    border-bottom-color: rgb(226, 226, 226);
                    border-image: initial;
                    border-left-style: initial;
                    border-left-color: initial;
                    height: 1125px;
                    position:relative;
                    overflow: visible;"
               ui-jp="mCustomScrollbar">


            <div class="box border-box mt-10 ml-10 mr-10" style="height: 345px;">
              <div class="box-header">
                <h4>결재자 관리</h4>
                <small>선택한 위치의 결재자 목록을 관리합니다. (사번 또는 dl)</small>
              </div>
              <div class="box-body">

                <!-- data-rel 속성은 동작 구현을 위한 임시 속성 : 개발 적용 시 제거 -->
                <div class="dropdown align-middle d-inline-block mb-20" style="width:100%">
                  <div class="input-group" data-toggle="dropdown">
                    <span class="input-group-addon title">타이틀</span>
                    <input type="text" class="form-control" placeholder="텍스트를 입력하세요" autocomplete="off" data-rel="ndk-input-autocomplete">
                    <button type="button" class="btn btn-m search">
                      <i class="icon-search"></i>
                    </button>
                  </div>
                  <div class="dropdown-menu">
                    <div style="max-height:350px" ui-jp="mCustomScrollbar">
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text"></span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                      <a class="dropdown-item">1뎁스 &gt; 2뎁스 &gt; 3뎁스 &gt; 4뎁스 &gt;
                        <span class="text-light-blue" data-rel="ndk-autocomplete-text">검색어</span>
                      </a>
                    </div>
                  </div>
                </div>


                <div class="box-tbl mt-0">
                  <div class="scroll-tbl">
                    <div class="thead">
                      <table class="tbl">
                        <thead>
                        <tr>
                          <th>구분1</th>
                          <th>구분2</th>
                          <th>구분3</th>
                          <th>구분4</th>
                          <th>구분5</th>
                          <th>구분6</th>
                        </tr>
                        </thead>
                      </table>
                    </div>
                    <div class="tbody" style="height:100px" ui-jp="mCustomScrollbar" ui-options="{theme:'dark-thick'}">
                      <table class="tbl">
                        <tbody>
                        <tr>
                          <td>내용1</td>
                          <td>내용2</td>
                          <td>내용3</td>
                          <td>내용4</td>
                          <td>내용5</td>
                          <td>내용6</td>
                        </tr>
                        <tr>
                          <td>내용1</td>
                          <td>내용2</td>
                          <td>내용3</td>
                          <td>내용4</td>
                          <td>내용5</td>
                          <td>내용6</td>
                        </tr>
                        <tr>
                          <td>내용1</td>
                          <td>내용2</td>
                          <td>내용3</td>
                          <td>내용4</td>
                          <td>내용5</td>
                          <td>내용6</td>
                        </tr>
                        <tr>
                          <td>내용1</td>
                          <td>내용2</td>
                          <td>내용3</td>
                          <td>내용4</td>
                          <td>내용5</td>
                          <td>내용6</td>
                        </tr>
                        <tr>
                          <td>내용1</td>
                          <td>내용2</td>
                          <td>내용3</td>
                          <td>내용4</td>
                          <td>내용5</td>
                          <td>내용6</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="box border-box mt-10 ml-10 mr-10" style="height: 745px;">
              <div class="box-header">
                <h4>참조자 관리</h4>
                <small>선택한 위치의 참조자 목록을 관리합니다. (사번 또는 dl)</small>
              </div>
              <div class="box-body">

                <div :class="['input-group mb-20', searchType === 'dl' ? 'stepper' : '']">
                  <Dropdown v-model="searchType" :datasource="searchTypeList" title="" :isSelectionFirstData="true" inline="inline"/>
                  <input type="text" class="form-control" v-model="term">
                  <button v-if="searchType == 'name'" type="button" class="btn btn-m search">
                    <i class="icon-search"></i>
                  </button>

                  <span v-if="searchType == 'dl'" class="input-group-btn ml-10">
                    <button class="btn btn-m line-2">
                      <i class="icon-plus"></i>
                    </button>
                  </span>
                </div>



                <div class="input-group mb-20">
                  <multiselect :value="refereeSearchValue" v-model="refereeSelectedItem" :options="empList" :custom-label="searchLabel" placeholder="임직원검색" track-by="empEmail"
                               deselect-label="취소"
                               select-label="선택"
                               :preserve-search="true"
                               :searchable="true"
                               :internal-search="false"
                               :clear-on-select="false"
                               @search-change="asyncFind">
                    <template slot="singleLabel" slot-scope="{ option }">
                      <div class="single-select-label">{{ option.empName }} [{{option.empTeam}}][{{option.empEmail}}]</div>
                    </template>
                    <span slot="noResult">결과가 없습니다.</span>
                    <span slot="noOptions">목록이 없습니다.</span>
                  </multiselect>
                </div>



<!--                <div class="input-group stepper mb-20" data-toggle="dropdown">-->
<!--                  <span class="input-group-addon title">참조자</span>-->
<!--                  <input type="text" class="form-control" placeholder="기본">-->
<!--                  <span class="input-group-btn ml-10">-->
<!--                    <button class="btn btn-m line-2">-->
<!--                      <i class="icon-plus"></i>-->
<!--                    </button>-->
<!--                  </span>-->
<!--                </div>-->

                <div class="box-tbl mt-0">
                  <div class="scroll-tbl">
                    <div class="thead">
                      <table class="tbl">
                        <thead>
                        <tr>
                          <th>구분1</th>
                          <th>구분2</th>
                          <th>구분3</th>
                          <th>구분4</th>
                          <th>구분5</th>
                          <th>구분6</th>
                        </tr>
                        </thead>
                      </table>
                    </div>
                    <div class="tbody" style="height:100px" ui-jp="mCustomScrollbar">
                      <table class="tbl">
                        <tbody>
                        <tr>
                          <td>내용1</td>
                          <td>내용2</td>
                          <td>내용3</td>
                          <td>내용4</td>
                          <td>내용5</td>
                          <td>내용6</td>
                        </tr>
                        <tr>
                          <td>내용1</td>
                          <td>내용2</td>
                          <td>내용3</td>
                          <td>내용4</td>
                          <td>내용5</td>
                          <td>내용6</td>
                        </tr>
                        <tr>
                          <td>내용1</td>
                          <td>내용2</td>
                          <td>내용3</td>
                          <td>내용4</td>
                          <td>내용5</td>
                          <td>내용6</td>
                        </tr>
                        <tr>
                          <td>내용1</td>
                          <td>내용2</td>
                          <td>내용3</td>
                          <td>내용4</td>
                          <td>내용5</td>
                          <td>내용6</td>
                        </tr>
                        <tr>
                          <td>내용1</td>
                          <td>내용2</td>
                          <td>내용3</td>
                          <td>내용4</td>
                          <td>내용5</td>
                          <td>내용6</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {defineComponent} from "vue";
import PageHeader from "@/layout/PageHeader.vue";
import Dropdown from "@/components/Dropdown.vue"
import Multiselect from "vue-multiselect";

export default defineComponent({
  components: {Multiselect, Dropdown, PageHeader},
  data(){
    return {
      searchTypeList: [{name: '이름', value: 'name'}, {name: 'DL', value: 'dl'}],
      searchType: 'name',
      term: null,
      refereeSearchValue: null,
      refereeSelectedItem: null,
      empList: []
    }
  },
  methods: {
    searchLabel ({ empName, empTeam, empEmail }) {
      return `${empName} [${empTeam}][${empEmail}]`
    },
    asyncFind(query){
      if(query == ''){
        this.selectedItem = null;
        this.empList = [];
        return;
      }
      if(query.length < 2) {
        return;
      }
      var that = this;
      this.$http.get('/api/private/emp/search'+'?empName='+ query)
          .then((result) => {
            that.empList = _.uniqBy(result.data, x => x.empEmail);
          }).catch((e) =>{
      })
    },
  }
})
</script>

<style>

.multiselect__tags {
  background-color: #FFFFFF !important;
  border-color: #c8c8c8 !important;
}

</style>